import React, { useState } from 'react';
import { Card, Container, Row, Col, Modal } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import 'bootstrap/dist/css/bootstrap.min.css';
import noseImage3 from '../images/doll.png';
import noseImage4 from '../images/teddybearnose.webp';
import noseImage5 from '../images/dogNose.png';
import noseImage6 from '../images/softNose.png';
import './EyeCategory.css';

const products = [
  {
    title: 'Dog & Cat Nose',
    image: noseImage5,
    alt: 'plastic toy nose for dog and cat soft toys manufacturer India',
  },
  {
    title: 'Doll Nose',
    image: noseImage3,
    alt: 'doll nose plastic toy accessories supplier India',
  },
  {
    title: 'Teddy Bear Fluffy Nose',
    image: noseImage6,
    alt: 'fluffy teddy bear nose for plush toys supplier India',
  },
  {
    title: 'Teddy Bear Nose',
    image: noseImage4,
    alt: 'plastic teddy bear nose manufacturer India bulk supply',
  },
];

const NoseCategory = () => {
  const [show, setShow] = useState(false);
  const [modalImage, setModalImage] = useState('');

  const handleClose = () => setShow(false);
  const handleShow = (image) => {
    setModalImage(image);
    setShow(true);
  };

  return (
    <>
      {/* 🔥 SEO META */}
      <Helmet>
        <title>
          Plastic Safety Noses Manufacturer in India | Soft Toy Noses Bulk Supplier | Pushkar Enterprises
        </title>

        <meta
          name="description"
          content="Pushkar Enterprises is a leading toy nose manufacturer in India. Supplier of plastic teddy bear noses, doll noses, and soft toy accessories in bulk."
        />

        <meta
          name="keywords"
          content="toy nose manufacturer India, plastic safety nose supplier, teddy bear nose wholesale, doll nose supplier India, soft toy accessories manufacturer"
        />

        <link rel="canonical" href="https://pushkar-enterprises.web.app/nose" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* 🔥 MAIN HEADING */}
      <header>
        <h1 className="category-heading">
          Toy Nose Manufacturer in India
        </h1>

        <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
          Plastic Teddy Bear Nose, Doll Nose & Soft Toy Nose Supplier
        </h2>
      </header>

      {/* 🔥 SEO CONTENT */}
      <Container style={{ maxWidth: "900px", marginBottom: "30px" }}>
        <p>
          Pushkar Enterprises is a trusted <strong>toy nose manufacturer in India </strong> 
            high-quality <strong>plastic noses for soft toys, teddy bears, and dolls</strong>. 
          Our products are designed for durability, smooth finish, and strong fitting in plush toys.
        </p>

        <p>
          We supply a wide range of <strong>teddy bear noses, doll noses, and animal noses </strong> 
          in different sizes, shapes, and materials. Our products are widely used by 
          toy manufacturers, exporters, and wholesalers across India.
        </p>
      </Container>

      {/* PRODUCT GRID */}
      <main>
        <Container className="eye-category">
          <Row className="card-container">
            {products.map((product, index) => (
              <Col md={3} sm={6} xs={12} className="mb-3" key={index}>
                <Card
                  className="product-card"
                  onClick={() => handleShow(product.image)}
                >
                  <Card.Img
                    variant="top"
                    src={product.image}
                    alt={product.alt}
                    loading="lazy"
                  />
                  <Card.Body>
                    <Card.Title>{product.title}</Card.Title>
                    <Card.Text>Available for Bulk Orders</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>

        {/* 🔥 EXTRA SEO CONTENT */}
        <Container style={{ maxWidth: "900px", marginTop: "20px" }}>
          <h2>Bulk Supply of Toy Noses in India</h2>

          <p>
            As a Delhi-based manufacturer, we specialize in bulk supply of 
            plastic toy noses for manufacturers and exporters. Our focus on 
            quality, pricing, and timely delivery makes us a reliable partner 
            in the soft toy industry.
          </p>

          <p>
            Contact Pushkar Enterprises for wholesale toy noses and custom requirements.
          </p>
        </Container>

        {/* MODAL */}
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Body>
            <img src={modalImage} alt="toy nose product" className="img-fluid" />
          </Modal.Body>
        </Modal>

        {show && (
          <button
            type="button"
            className="close-btn"
            onClick={handleClose}
          >
            &times;
          </button>
        )}
      </main>
    </>
  );
};

export default NoseCategory;